import logo from '../assets/logo.png';

/**
 * The Golden Lotus mark.
 *
 * The source artwork is a square vertical lock-up: the lotus roundel sits in
 * the upper portion (centred at ~35.5% of the height, ~58% of the width) with
 * the wordmark beneath it. `mark` crops to just the roundel by scaling the
 * image up and offsetting it so the roundel's centre lands in the middle of
 * the box — the numbers below are derived from those measurements.
 */
const SCALE = 1 / 0.58;      // roundel occupies ~58% of the artwork's width
const CENTRE_Y = 0.355;      // roundel centre, as a fraction of artwork height

export default function Logo({ size = 40, showText = false, mark = true, style }) {
  const scaled = size * SCALE;
  const offsetX = -(scaled - size) / 2;                 // roundel is centred horizontally
  const offsetY = size / 2 - CENTRE_Y * scaled;         // pull the roundel's centre to the middle

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 11, ...style }}>
      <div style={{
        width: size, height: size, flexShrink: 0,
        position: 'relative', overflow: 'hidden',
      }}>
        <img
          src={logo}
          alt="Golden Lotus"
          style={mark
            ? { position: 'absolute', width: scaled, height: scaled, left: offsetX, top: offsetY }
            : { width: size, height: size, objectFit: 'contain' }}
        />
      </div>

      {showText && (
        <div style={{ lineHeight: 1.12 }}>
          <div style={{
            fontFamily: 'var(--font-display)', fontSize: size * 0.42, fontWeight: 600,
            letterSpacing: '0.16em', color: 'var(--gold-300)', whiteSpace: 'nowrap',
          }}>
            GOLDEN LOTUS
          </div>
          <div style={{
            fontSize: Math.max(size * 0.2, 8), letterSpacing: '0.2em',
            color: 'var(--text-lo)', marginTop: 3, fontWeight: 500, whiteSpace: 'nowrap',
          }}>
            MICE &amp; CORPORATE TRAVEL
          </div>
        </div>
      )}
    </div>
  );
}
